@import 'styles/variables';
@import 'styles/mixins';

.profileHeader {
  margin-bottom: 48px;
}

.field {
  margin-bottom: 20px;
  input,
  textarea,
  select {
    color: $grey-90;
    @include md-regular;
    min-height: 40px;
  }

  textarea,
  select {
    border: 1px solid $grey-20;
    &:focus {
      border-color: $green-50;
    }
  }
  ::placeholder {
    color: $grey-30;
  }
  label {
    @include sm-regular;
    color: $grey-40;
  }
  .checkboxLabel {
    @include md-regular;
    margin-left: 6px;
    cursor: pointer;
  }
  &.checkbox {
    padding-left: 1px;
  }
}

.coverImageControls {
  align-items: flex-start !important;
  margin-top: 15px;
}

.profileImage {
  bottom: -30%;
}

.inputOverrides {
  select,
  textarea {
    border-radius: 4px;
    padding: 0 16px;
    width: 100%;
  }

  select {
    height: 38.67px;
  }

  textarea {
    padding: 16px;
  }
}
